/* Подсказки вместо системных title (nav.js): крупнее, контрастнее, без секундной задержки.
   title переносится в data-tip при первом наведении. Ставится один раз на документ. */
let installed = false;
export function installTooltips() {
  if (installed) return;
  installed = true;
  let tipEl: HTMLDivElement | null = null;
  let timer: ReturnType<typeof setTimeout> | null = null;
  let cur: HTMLElement | null = null;
  const box = () => tipEl || (tipEl = Object.assign(document.body.appendChild(document.createElement('div')), { className: 'tip' }));
  const show = (t: HTMLElement, text: string) => {
    if (!t.isConnected) return;
    const b = box();
    b.textContent = text;
    b.className = 'tip on';
    const r = t.getBoundingClientRect(),
      w = b.offsetWidth,
      h = b.offsetHeight;
    let x = r.left + r.width / 2 - w / 2,
      y = r.bottom + 8;
    if (y + h > innerHeight - 8) y = r.top - h - 8;
    x = Math.max(8, Math.min(innerWidth - w - 8, x));
    b.style.left = x + 'px';
    b.style.top = y + 'px';
  };
  const hide = () => {
    if (timer) clearTimeout(timer);
    timer = null;
    cur = null;
    tipEl?.classList.remove('on');
  };
  document.addEventListener('mouseover', (e) => {
    const t = (e.target as Element).closest?.('[title],[data-tip]') as HTMLElement | null;
    if (!t || t === cur) return;
    hide();
    cur = t;
    if (t.hasAttribute('title')) {
      t.dataset.tip = t.getAttribute('title') || '';
      t.removeAttribute('title');
    }
    const text = (t.dataset.tip || '').trim();
    if (!text) return;
    timer = setTimeout(() => show(t, text), 120);
  });
  document.addEventListener('mouseout', (e) => {
    if (cur && !(e.relatedTarget && cur.contains(e.relatedTarget as Node))) hide();
  });
  document.addEventListener('mousedown', hide, true);
  addEventListener('scroll', hide, true);
  addEventListener('keydown', hide, true);
}
